import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import "../../../components/UI Component/Modal/commonModals.css";
import CheckMark from "../../../assets/image-removebg-check.png";
import Loader from "../../UI Component/Loader/Loader";
import "./style/shareModal.css"

const ReScheduledConfirmModal = ({
    show,
    closeReschedule,
    }) => {
        const [loading, setloading] = useState(false);

    return (
        <>
        {loading ? <Loader /> : null}
            {show?<Modal show={show} onHide={closeReschedule} backdrop="static" centered>
                <Modal.Body>
                    <div className="d-flex align-items-center justify-content-end w-100 px-4 pt-2">
                        <div onClick={closeReschedule} className="cursor-pointer">
                            Close X
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-center flex-column p-4">
                        <div>
                            <img src={CheckMark} />
                        </div>
                        <div className="reschedule-title">Appointment Rescheduled</div>
                        <div className="reschedule-text px-3 my-3">
                            Your appointment has been rescheduled
                        </div>
                        <button className="btn primary-cta-button rounded-pill mt-3 mb-3 w-75 p-3" onClick={closeReschedule} >
                            Okay
                        </button>
                    </div>
                </Modal.Body>
            </Modal>:null}
        </>
    );
};

export default ReScheduledConfirmModal;